import { AproeProjectForm, TestRequestProjectInfoResponse } from "./models";
import * as Fields from "./fieldNames";
import parseDate from "../../../functions/parseDate.function";

export default function mapFromResponse(response: TestRequestProjectInfoResponse | null): AproeProjectForm {
  return {
    [Fields.AWAITING_FEEDBACK]: response?.[Fields.AWAITING_FEEDBACK] || false,
    [Fields.COMPLEXITY]: response?.[Fields.COMPLEXITY] || "",
    [Fields.FINISHING_DATE]: response?.[Fields.FINISHING_DATE] || "",
    [Fields.SOLUTION_TYPE]: response?.[Fields.SOLUTION_TYPE] || "",
    [Fields.SUPPORT_TYPE]: response?.[Fields.SUPPORT_TYPE] || "",
    [Fields.TAPE_USED]: response?.[Fields.TAPE_USED] || "",
  };
}
